import Api from './Api';

class TipoAtendimentoService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/tipos-atendimento', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/tipo-atendimento', data);
    }

    return this.$api.put(`/tipo-atendimento/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/tipo-atendimento/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/tipo-atendimento/${id}`);
  }
}

export default new TipoAtendimentoService();
